// WhitelabelAuthWindow — a MIXIN that gives the shared LoginWindow its
// white-label shape on the pages that place it (signup, reset-password):
//
//   LoginWindow: { extends: ['WhitelabelAuthWindow', 'LoginWindow'], … }
//
// On a branded host (root.whitelabelBrand set) the window becomes ONE centred
// column at the branded sign-in's card measure and inset, the heading block
// centres, and the OAuth group trades the platform's "another way to sign in"
// heading for a plain "or" rule with full-width provider buttons — the same
// family as the branded sign-in (WhitelabelSignin.js; Nika 2026-10-14).
//
// Why a mixin and not edits to LoginWindow.js: the shared Symbols login
// component carries no branding logic (locked by workspace
// __tests__/whitelabelBrand.test.js, "SYMBOLS IS UNTOUCHED"). Every value
// here sits in an `.isBranded` block (Rule 19) or a brand-gated `hide`, so on
// the platform the window renders exactly as LoginWindow declares it.
//
// Child keys are deliberately non-colliding (OrDivider, OrRule_1/2, OrWord).
export const WhitelabelAuthWindow = {
  subscribeTo: ['whitelabelBrand'],
  isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
  '.isBranded': {
    width: '100%',
    maxWidth: 'overlaySm',
    minHeight: 'auto',
    padding: 'B1',
    gap: 'A',
    align: 'stretch flex-start'
  },

  ModalHeader: {
    Hgroup: {
      isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
      '.isBranded': { textAlign: 'center', align: 'center center', width: '100%' },
      H: {
        isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
        '.isBranded': { fontSize: 'B1' }
      }
    }
  },

  Flex: {
    isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
    '.isBranded': { flow: 'column', gap: 'A', padding: 'Y 0 0' },

    RequestAccessButtons: {
      isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
      '.isBranded': { gap: 'Z' },
      OrDivider: {
        hide: (el, s) => !s.root.whitelabelBrand,
        // First in the group: a mixin's new child lands AFTER the base's.
        order: '-1',
        display: 'flex',
        align: 'center center',
        gap: 'Z',
        width: '100%',
        OrRule_1: { flex: '1', height: 'hairline', background: 'line' },
        OrWord: {
          tag: 'span',
          fontSize: 'Z',
          color: 'caption',
          text: '{{ auth.whitelabel.or | polyglot }}'
        },
        OrRule_2: { flex: '1', height: 'hairline', background: 'line' }
      },
      Hgroup: {
        hide: (el, s) => !!s.root.whitelabelBrand
      },
      Flex: {
        isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
        '.isBranded': { flow: 'y', gap: 'Z', width: '100%' },
        GoogleSignInButton: {
          isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
          '.isBranded': {
            margin: '0',
            width: '100%',
            align: 'center center',
            round: 'radiusControl'
          }
        },
        GithubSignInButton: {
          isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
          '.isBranded': {
            margin: '0',
            width: '100%',
            align: 'center center',
            round: 'radiusControl'
          }
        }
      }
    }
  }
}
